import FormRadioGroup from 'components/ui/FormRadioGroup'
import FormCheckBoxGroup from 'components/ui/FormCheckBoxGroup'
import { FormQuestions } from './helpers'

type Props = {
  questions: FormQuestions
}

type QuestionForOptions = {
  itemAnswers:
    | {
        id: number | null
        text: string | null
        adjustment: {
          __typename: 'Money'
          cents: number
          formatted: string
        } | null
      }[]
    | null
}

const ItemModalQuestions = ({ questions }: Props) => {
  const getOptions = (question: QuestionForOptions) => {
    return question.itemAnswers!.map((a) => ({
      label: `${a.text}${
        a.adjustment?.cents && a.adjustment?.cents > 0
          ? ` (+${a.adjustment?.formatted})`
          : ''
      }`,
      value: a.id!
    }))
  }

  return (
    <>
      {questions.map((question) => {
        let label = question.text
        const extraLabels = []
        if (question.required) {
          extraLabels.push('required')
        }
        if (question.maxAnswers && question.maxAnswers > 0) {
          extraLabels.push(`up to ${question.maxAnswers}`)
        }
        if (extraLabels.length > 0) {
          label += ` (${extraLabels.join(', ')})`
        }
        return (
          <div key={question.id} className="my-5">
            {question.questionType === 'checkbox' && (
              <FormCheckBoxGroup
                label={label}
                maxOptions={
                  question.maxAnswers && question.maxAnswers > 0
                    ? question.maxAnswers
                    : null
                }
                name={`question-${question.id}`}
                options={getOptions(question)}
                questionId={question.id}
              />
            )}
            {question.questionType === 'dropdown' && (
              <FormRadioGroup
                label={label}
                name={`question-${question.id}`}
                options={getOptions(question)}
                questionId={question.id}
              />
            )}
          </div>
        )
      })}
    </>
  )
}

export default ItemModalQuestions
